goog.provide("shadow.js.shim.module$$mui$material$Avatar");
goog.provide("module$shadow_js_shim_module$$mui$material$Avatar");
shadow.js.shim.module$$mui$material$Avatar = shadow.js.nativeProvides["@mui/material/Avatar"] = shadow$bridge("@mui/material/Avatar");
module$shadow_js_shim_module$$mui$material$Avatar.default = shadow.js.shim.module$$mui$material$Avatar;
